const onlyNumber=(e)=>{
       const symbolsArr = ['e', 'E', '+', '-', '.'];
       return  symbolsArr.includes(e.key) && e.preventDefault()
}
export default onlyNumber